@if (installerForm) {
  <ion-item lines="full">
    <ion-title class="ion-no-padding ion-padding-vertical"
      ><b>{{ 'installation_addInstaller' | translate }}</b></ion-title
    >
    <ion-buttons slot="end">
      <ion-button (click)="dismiss('cancel')"
        ><ion-icon name="close-outline"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-item>
  <div class="ion-margin-bottom">
    <form
      [formGroup]="installerForm"
      (submit)="onSubmitInstallerAdd()"
      class="ion-margin-bottom"
      novalidate
    >
      <ion-grid class="ion-no-padding ion-margin-top">
        <ion-row class="mb-10px">
          <ion-col>
            <ion-label class="ion-padding panel-label-text">
              {{ 'user_email' | translate }}
            </ion-label>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div class="ion-no-padding ion-padding-horizontal">
              <ion-input
                placeholder="{{ 'user_email' | translate }}"
                formControlName="email"
              ></ion-input>
              @if (errorKey()) {
                <ion-text color="danger" class="error-text">
                  {{ errorKey() | translate }}
                </ion-text>
              }
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </div>
  <ion-footer>
    <div class="ion-text-center ion-padding">
      <ion-button
        id="showmoddel"
        color="primary"
        class="ion-align-self-center"
        (click)="dismiss('cancel')"
        ><small>
          {{ 'general_cancel' | translate }}
        </small></ion-button
      >
      <ion-button
        type="submit"
        id="showsuccessmoddel"
        (click)="onSubmitInstallerAdd()"
        color="primary"
        class="ion-align-self-center"
        [disabled]="!installerForm?.valid || isSubmitting()"
        ><small> {{ 'general_ok' | translate }}</small>
      </ion-button>
    </div>
  </ion-footer>
}
